import { CARD_API_ENDPOINT } from '@/config/consts'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAccount } from 'wagmi'
import { createSmartFetch } from './useAuthenticatedMutation'

interface UpdateHookRequest {
  cardID: string
  hookType: string
  chainID: number
  config: Record<string, unknown>
}

export function useUpdateCardHook() {
  const { address } = useAccount()
  const queryClient = useQueryClient()
  const url = `${CARD_API_ENDPOINT}/v1/vendor/cards/hook`

  const mutation = useMutation<void, Error, UpdateHookRequest>({
    mutationKey: ['update-card-hook'],
    mutationFn: async (request: UpdateHookRequest) => {
      const fetchFn = createSmartFetch(url, { method: 'PATCH' })
      await fetchFn(request)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-cards', address] })
    },
  })

  return {
    updateHook: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  }
}

export function useDeleteCardHook() {
  const { address } = useAccount()
  const queryClient = useQueryClient()

  const mutation = useMutation<void, Error, string>({
    mutationKey: ['delete-card-hook'],
    mutationFn: async (cardID: string) => {
      const url = `${CARD_API_ENDPOINT}/v1/vendor/cards/hook/${cardID}`
      const fetchFn = createSmartFetch(url, { method: 'DELETE' })
      await fetchFn(null)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-cards', address] })
    },
  })

  return {
    deleteHook: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  }
}
